import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';

@invoke
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class TabsProductListComponentEditor {
  constructor() {}

  onInit() {
    globalEvent({
      type: 'click',
      event: {
        event: 'select-tab',
        callback: TabsProductListComponentEditor.selectTab,
      },
    });

    TabsProductListComponentEditor.initTab();
  }

  static selectTab(e) {
    e.preventDefault();
    const hash = e.target?.hash;
    window.history.pushState({}, '', hash);

    const element = e.target as HTMLElement;
    const navElement = element.closest('.nav-item');
    const parentElement = element.closest('.nav-tabs');
    const selectedTab = parentElement.querySelector(':scope > .nav-item.active') as HTMLElement;
    selectedTab?.classList.remove('active');
    navElement.classList.add('active');

    const component = navElement.closest('[data-container="tabs-list-component"]');
    const selectedTabContent = component.querySelector(`.tab-pane.active`);
    selectedTabContent?.classList.remove('active');
    const tabTarget = component.querySelector(`${hash}`);
    tabTarget.classList.add('active');
  }

  static initTab() {
    const hash = window.location.hash;
    if (!hash) return;
    const element = document.querySelector(`[href="${hash}"]`) as HTMLElement;
    if (element) {
      element.click();
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
